var exports = {
  "qr": "xcc377c0b--12af1e--footer",
  "h_": "xcc377c0b--12af1e--description",
  "x6": "xcc377c0b--12af1e--button",
};

module.exports = exports;
